import { useEffect, useState } from 'react';
import {
  useRecoilValue,
} from 'recoil';

import { userState } from './userState';
import Vault from './Vault';
import { Loading } from '../components/Styles';

const DefaultLoadingComponent = () => (
  <Loading>
    loading your profile
  </Loading>
);

const alwaysRequired = window.location.href.includes('market2day-demo.')
  || window.location.href.includes('market2day-staging.');

const withAuthentication = (
  Container,
  requestRequired = true,
  LoadingComponent = DefaultLoadingComponent,
) => (props) => {
  const [attempted, setAttempted] = useState(false);
  const { history, setAuthToken } = props;
  const user = useRecoilValue(userState);
  const required = alwaysRequired || requestRequired;
  useEffect(() => {
    if (!user) {
      // no user is logged in, so try to log one in
      Vault.get(Vault.keys.AUTH_TOKEN)
        .then((token) => {
          setAuthToken(
            token,
            (err) => {
              // setAuthToken ran; decide whether to show the component
              // based on the required flag and error status here
              if (err) {
                if (required) {
                  // setting authToken failed, but auth is required; sign in
                  history.push('/signin');
                } else {
                  // setting authToken failed, but auth is not required, fine
                  setAttempted(true);
                }
              } else {
                // successful sign in
                setAttempted(true);
              }
            },
          );
        })
        .catch((err) => {
          // Vault.get ran; decide whether to show the component
          // based on the required flag and error status here
          if (err) {
            Console.log(err);
            if (required) {
              // nothing in Vault, but auth is required; sign in
              history.push('/signin');
            } else {
              // nothing in Vault, and that's OK if !required
              setAttempted(true);
            }
          }
        });
    }
  }, [history, user, setAuthToken]);
  if (user || attempted) {
    return <Container user={user} {...props} />;
  }
  return <LoadingComponent {...props} />;
};

export default withAuthentication;
